module.exports = __webpack_public_path__ + "img/4.c188c91a.jpg";